import type {AxiosInstance} from "axios";
import type {MetlJobExport} from "../metl-models/exports/MetlJobExport.ts";
import {exportable, type Exportable} from "./util/Exportable.ts";
import type {OrchestrationJob} from "../metl-models/jobs/Orchestration.ts";
import type {TransformationJob} from "../metl-models/jobs/Transformation.ts";

export interface MetlJobApi extends Exportable<MetlJobExport> {
    debug(): Promise<OrchestrationJob | TransformationJob>
}

export function metlJobApi(axios: AxiosInstance, baseUrl: string): MetlJobApi {
    return exportable(axios, baseUrl, {
        debug: async () => await axios.get<OrchestrationJob | TransformationJob>(`${baseUrl}/debug`).then(r => r.data)
    })
}